import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';

interface TimeframeFilterProps {
  value: string;
  onChange: (value: string) => void;
  options?: { value: string; label: string }[];
  label?: string;
  className?: string;
}

const TimeframeFilter: React.FC<TimeframeFilterProps> = ({
  value,
  onChange,
  options = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'yearly', label: 'Yearly' },
  ],
  label = 'Timeframe Filter:',
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption =
    options.find((option) => option.value === value) || options[0];

  return (
    <div className={`inline-block relative ${className}`}>
      <span className="text-sm font-medium text-gray-700 mr-2">{label}</span>
      <div className="relative inline-block">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center justify-between px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-w-[120px]"
        >
          <span>{selectedOption.label}</span>
          <ChevronDownIcon className="ml-2 h-4 w-4" />
        </button>

        {isOpen && (
          <div className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg border border-gray-300">
            <ul className="max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm">
              {options.map((option) => (
                <li
                  key={option.value}
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                  className={`cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-blue-50 ${
                    option.value === value ? 'bg-blue-100' : ''
                  }`}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeframeFilter;
